import { render, staticRenderFns } from "./UserPersonalData.vue?vue&type=template&id=6c0f562d&scoped=true"
import script from "./UserPersonalData.vue?vue&type=script&lang=js"
export * from "./UserPersonalData.vue?vue&type=script&lang=js"
import style0 from "./UserPersonalData.vue?vue&type=style&index=0&id=6c0f562d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f562d",
  null
  
)

export default component.exports